import 'firebase/auth';

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyB49Cca_vUCMThbAe3BeX6CsaQvlBsGKvU',
  authDomain: 'mvp-avatar.firebaseapp.com',
  projectId: 'mvp-avatar',
  storageBucket: 'mvp-avatar.firebasestorage.app',
  messagingSenderId: '597844190070',
  appId: '1:597844190070:web:79050d076c9e5ec9c5d057',
  measurementId: 'G-3T6X3E861S',
};
const app = initializeApp(firebaseConfig);

const auth = getAuth();

export { app, auth };
